import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
import _imports_0 from '@/assets/images/providers/allproviders.png';
const _hoisted_1 = { class: "footer-section" };
const _hoisted_2 = { class: "container" };
const _hoisted_3 = { class: "pt-4 footer-area" };
const _hoisted_4 = {
    key: 0,
    class: "tw-mt-8"
};
const _hoisted_5 = { class: "tw-text-center tw-text-xl tw-font-semibold md:tw-mb-0 tw-mb-4" };
const _hoisted_6 = { class: "footer-bottom" };
const _hoisted_7 = { class: "row justify-content-center align-items-center" };
const _hoisted_8 = { class: "order-1 col-lg-7 d-flex justify-content-center justify-content-lg-center order-lg-0" };
const _hoisted_9 = { class: "text-center copyright" };
const _hoisted_10 = { class: "tw-text-sm tw-mb-8" };
const _hoisted_11 = { class: "tw-text-sm" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _cache[1] || (_cache[1] = _createElementVNode("div", { class: "row" }, [
                    _createElementVNode("div", { class: "col-xl-12" })
                ], -1)),
                ($setup.isHomePage)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.$t('ourProviders')), 1),
                        _cache[0] || (_cache[0] = _createElementVNode("img", { src: _imports_0 }, null, -1))
                    ]))
                    : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("div", _hoisted_9, [
                                _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t('betriderUsesCookies')), 1),
                                _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.$t('copyright')), 1)
                            ])
                        ])
                    ])
                ])
            ])
        ])
    ]));
}
